<div class="concern-modal">
  <div class="language-selection">
    <button class="language-button" type="button" [class.active]="language === 'DE'" (click)="setLanguage('DE')">DE</button>
    <button class="language-button" type="button" [class.active]="language === 'EN'" (click)="setLanguage('EN')">EN</button>
  </div>

  <h3 class="title">{{ titleText }}</h3>

  <div class="list-container">
    @for (item of sub(); track item._id) {
      <button class="concern-item" type="button" (click)="selectItem(item)">
        <span>{{ getItemTitle(item) }}</span>
        <span class="arrow">›</span>
      </button>
    }

    @if (isEmpPIN()) {
      <button class="concern-item" type="button" (click)="employee()">
        <span>{{ employeeButtonText }}</span>
        <span class="arrow">›</span>
      </button>
    }
  </div>
</div>
